import { render, staticRenderFns } from "./MatchExpressions.vue?vue&type=template&id=2b2587fc&scoped=true&"
import script from "./MatchExpressions.vue?vue&type=script&lang=js&"
export * from "./MatchExpressions.vue?vue&type=script&lang=js&"
import style0 from "./MatchExpressions.vue?vue&type=style&index=0&id=2b2587fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2587fc",
  null
  
)

export default component.exports